import axios from "axios";

import { CLOUD_FUNCTION_BASE_URL } from "@/data/urls";

export type TGetImageProcessData = {
  status: true;
  data: {
    name: string;
    timeSaved: number;
    albums: number;
    processedImages: number;
    imageUrl: string;
  };
  error: null;
};

type TError = {
  code: number;
  message: string;
};

export type TGetImageProcessDataRes = {
  data: TGetImageProcessData | null;
  error: TError | null;
  status: number;
};

const getImageProcessData = async (code: string) => {
  if (!code) return;

  const API_URL = `${CLOUD_FUNCTION_BASE_URL}/get-referrer-details-public-api/details`;

  const data = {
    code,
  };

  try {
    const response = await axios.post(API_URL, data);
    return response.data as TGetImageProcessData;
  } catch (err) {
    console.log("Err", err);
    if (axios.isAxiosError(err)) {
      console.log("Err", err);
      return err.response?.data as TGetImageProcessData;
    } else {
      console.error("An error occurred:", err);
      return null;
    }
  }
};

export default getImageProcessData;
